<template>
  <div>
    <i id="burgerSettings" class="fa fa-solid fa-bars fa-lg" />
        <b-popover @show="colSettingsClick" target="burgerSettings" triggers="hover" placement="bottom" id="column-settings-popover">
          {{$t('Exclude fast search fields')}}
          <b-list-group  >
            <b-list-group-item id="colSettings"
            style="margin:-2.2% -4% -3%; border:0px" class="d-flex "  v-for="item in searchSettingsFields" :key="item.key">
              <b-row @click="() => {item.is_selected = !item.is_selected}" id="rowPopoverBurgerSetting">
                <b-col cols="1" style="margin-right:1%" >
                  <b-form-checkbox switch v-model="item.is_selected"/>
                </b-col>
                <b-col style="margin-top:1%">
                  {{ $t(item.label)}}
                </b-col>
              </b-row>
            </b-list-group-item>

          </b-list-group>
        </b-popover>

    <TableManager
      ref="TableManager"
      v-if="state == 'User'"
      @filterChanged="filterChanged"
      @paginationChanged="paginationChanged"
      @customersChanged="customersChanged"
      :options="options"
      @ClickOnAddButton="showAddUser"
      @ClickOnSearchButton="refreshTable"
      @ClickOnClearButton="ClickOnClearButton"
      @ClickOnExtendedSearchButton="refreshTableExtSearch"
      @ClickOnRestoreSearchButton="restoreSearchButton"/>
    <Users
      ref="Users"
      v-if="state == 'User'"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      :curCustomers="curCustomers"
      :excludeShortSearchFields="searchSettingsFields"
      @ClickOnPaymentButton="ClickOnPaymentButton"
      v-model="totalRows"
      @rowClickHandler="rowClickHandler"
      @makeToasts="makeToasts"
      @sortingChanged="sortChanged"/>
    <TableManagerBottom style="margin:5px" ref="pagination"
      v-if="state == 'User'"
      :totalRows="totalRows"
      :perPage="perPage"
      @input="input"
      v-model="currentPage"/>
    <b-modal ref="refUserAccounts" hide-footer :title="$t('Select user account')" @hidden="isShowAccounts = false" size="lg">
      <Accounts v-if="isShowAccounts" :userId="user_id" @clickOnAccount="clickOnAccount" @makeToasts="makeToasts"></Accounts>
      <b-row>
        <b-col cols="9">
        </b-col>
        <b-col>
          <b-btn variant="secondary" @click="hideModal">{{ $t('Cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal ref="AddUser" id="AddUser" hide-footer @hidden="isShowAddUser = false" :title="$t('New customer')">
      <FormAddUser v-if="isShowAddUser" @refreshTable="refreshTable" @hideAddUser="hideAddUser" @makeToasts="makeToasts"></FormAddUser>
    </b-modal>
    <b-modal ref="refPayment" hide-footer @hidden="isShowPayment = false">
      <Payment :accountId="account_id" :userId="user_id" v-if="isShowPayment" @makeToasts="makeToasts" @load="load"  @close="closePayment()"></Payment>
    </b-modal>
    <b-modal ref="ExtSearch" id="ExtSearch" hide-footer  :title="$t('Ext search')" size="lg">
      <FormExtSearch @loadFromExtSearch="loadFromExtSearch"/>
    </b-modal>
  </div>
</template>

<script>
import Payment from '@/pages/users/formPayment'

import Accounts from '@/components/tables/users/Accounts.vue'
import Users from '@/components/tables/users/Users.vue'

import TableManager from '@/components/tables/TableManager'
import TableManagerBottom from '@/components/tables/TableManagerBottom'

import FormAddUser from './formAdd'
import FormClearCardUsers from './formClearCardUsers'

import FormExtSearch from './formExtSearch'
export default {
  components: {
    Payment,
    Accounts,
    Users,
    TableManager,
    TableManagerBottom,
    FormAddUser,
    FormClearCardUsers,
    FormExtSearch
  },
  data () {
    return {
      isCommonSearch: true,
      isCardUsersSelected: false,
      curCustomers: 0,
      isShowPayment: false,
      options: {
        isShowAddButton: true,
        isCustomers: true,
        isShowClearButton: false,
        isExtendSearch: true,
        isRestoredSearcher: true
      },
      searchSettingsFields: [
        {
          label: 'ID',
          value: 'user_id',
          is_selected: false
        },
        {
          label: 'Login',
          value: 'login',
          is_selected: false
        },
        {
          label: 'Name',
          value: 'full_name',
          is_selected: false
        },
        {
          label: 'email',
          value: 'email',
          is_selected: false
        },
        {
          label: 'Work phone',
          value: 'work_telephone',
          is_selected: false
        },
        {
          label: 'Home phone',
          value: 'home_telephone',
          is_selected: false
        },
        {
          label: 'Mobile phone',
          value: 'mobile_telephone',
          is_selected: false
        },
        {
          label: 'Mobile phone secondary',
          value: 'mobile_telephone_second',
          is_selected: false
        }
      ],
      fieldName: new Map([
        ['user_id', 0],
        ['login', 1],
        ['basic_account', 2],
        ['full_name', 3],
        ['email', 4],
        ['balance', 5]
      ]),
      isShowAccounts: false,
      isShowAddUser: false,
      user_id: null,
      account_id: null,
      filter: '',
      perPage: 20,
      total_rows: 0,
      currentPage: 1,
      state: 'User',
      currentRow: null,
      extQueries: null,
      sortingData: {sortBy: 'user_id', sortDesc: true}
    }
  },
  methods: {
    ClickOnClearButton () {
      this.$root.$emit('bv::show::modal', 'modalFormClearCardUsers', '#btnShow')
    },
    makeToasts (variant, body, title) {
      this.$root.$emit('makeToasts', variant, body, title)
    },
    load () {
      this.$refs.Users.load(this.filter)
    },
    refreshTable () {
      localStorage.setItem('ShortSearchv1', JSON.stringify(this.searchSettingsFields))
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
      this.currentRow = null
      this.isCommonSearch = true
      this.$refs.Users.refreshTable(this.filter)
      this.$refs.TableManager.filter = this.filter
      this.$refs.AddUser.hide()
    },
    refreshTableExtSearch () {
      this.$bvModal.show('ExtSearch')
    },
    restoreSearchButton () {
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
      if (this.$refs.Users.curPage === 1) {
        this.$refs.Users.refreshTable()
      }
      this.$refs.Users.curPage = 1
      this.isCommonSearch = true
      this.filter = ''
      this.$refs.TableManager.filter = ''
    },
    loadFromExtSearch (quries) {
      this.$bvModal.hide('ExtSearch')
      this.isCommonSearch = false
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
      quries.per_page = this.perPage
      quries.page = 1
      this.extQueries = quries
      this.currentRow = null
      this.$refs.Users.loadExtSearch(quries, {sortBy: 'user_id', sortDesc: true})
      this.$refs.AddUser.hide()
    },
    filterChanged (value) {
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
      this.$refs.Users.perPage = value
      if (this.currentPage === 1) {
        this.refreshTable()
      }
      this.$refs.pagination.setCurrentPage(1)
      this.currentPage = 1
    },
    customersChanged (value) {
      this.curCustomers = value
    },
    ClickOnPaymentButton (row) {
      this.user_id = row.user_id
      if (row.accounts.length === 1) {
        this.$refs.refUserAccounts.hide()
        this.account_id = row.accounts[0]
        this.isShowPayment = true
        this.$refs.refPayment.show()
        this.isShowAccounts = false
      } else {
        this.showModal()
      }
    },
    clickOnAccount (row) {
      this.$refs.refUserAccounts.hide()
      this.account_id = row.account_id
      this.isShowPayment = true
      this.$refs.refPayment.show()
      this.isShowAccounts = false
    },
    showModal () {
      this.isShowAccounts = true
      this.$refs.refUserAccounts.show()
    },
    hideModal () {
      this.isShowAccounts = false
      this.$refs.refUserAccounts.hide()
    },
    showAddUser () {
      this.isShowAddUser = true
      this.$refs.AddUser.show()
    },
    hideAddUser () {
      this.isShowAddUser = false
      this.$refs.AddUser.hide()
    },
    closePayment () {
      this.isShowPayment = false
      this.$refs.refPayment.hide()
    },
    input (pageNumber) {
      this.currentPage = pageNumber
    },
    rowClickHandler (row) {
      if (this.currentRow) {
        this.currentRow._rowVariant = ''
      }
      this.currentRow = row
      this.user_id = row.user_id
      this.$set(this.currentRow, '_rowVariant', 'info')
    },
    sortChanged (ctx) {
      this.$refs.pagination.setCurrentPage(1)
      this.sortingData.sortBy = ctx.sortBy
      this.sortingData.sortDesc = ctx.sortDesc
      this.currentPage = 1
      this.isCommonSearch
        ? this.$refs.Users.pageChanged(this.filter, this.currentPage, ctx)
        : this.$refs.Users.pageChanged(this.filter, this.currentPage, ctx, false, this.extQueries)
    }

  },
  watch: {
    searchSettingsFields (val) {
      localStorage.setItem('ShortSearchv1', JSON.stringify(val))
    },
    curCustomers () {
      if (this.curCustomers) {
        this.options.isShowClearButton = true
        this.isCardUsersSelected = true
      } else {
        this.options.isShowClearButton = false
        this.isCardUsersSelected = false
      }
    },
    currentPage () {
      if (this.isCommonSearch) {
        this.$refs.Users.pageChanged(this.filter, this.currentPage, this.sortingData)
      } else {
        this.$refs.Users.pageChanged(this.filter, this.currentPage, this.sortingData, false, this.extQueries)
      }
    }
  },
  computed: {
    totalRows: {
      get () {
        return this.$store.getters['Users/USERS'].total_rows
      },
      set (val) {
        return val
      }
    }
  },
  mounted () {
    let shortSearchData = localStorage.getItem('ShortSearchv1')
    if (shortSearchData !== null) {
      this.searchSettingsFields = JSON.parse(shortSearchData)
    }
    this.$store.dispatch('Users/GET_USERS_COUNT', 1).then(response => {
      let tmp = {
        isCard: 1,
        to: 0,
        from: 0
      }
      tmp.to = this.$store.getters['Users/USERS_COUNT'].count
      this.$store.dispatch('Users/GET_USERS_LIST', tmp)
    })
    this.$store.dispatch('Users/GET_CARD_POOLS')
    this.$store.dispatch('Users/USERS_SEARCH', {value: '',
      page: 1,
      per_page: 20,
      sort_field: 'user_id',
      is_desc: false })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/main.vue